import { Link } from "react-router-dom";
import { articles } from "@/mocks/gossipData";
import { formatCount } from "@/components/feature/ArticleCard";

export default function HomeHot() {
  const ranked = [...articles].sort((a, b) => b.readCount - a.readCount);
  const featured = articles.find((item) => item.isFeatured) ?? articles[0];
  const ranking = ranked.filter((item) => item.id !== featured.id).slice(0, 5);

  return (
    <section className="w-full px-4 py-14 md:px-6 md:py-20" aria-label="今日热瓜">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <span className="flex items-center gap-2 text-xs font-label uppercase tracking-widest text-primary-600">
            <i className="ri-fire-line" aria-hidden="true" />
            Today&apos;s Picks
          </span>
          <h2 className="mt-2 font-heading text-3xl text-foreground-950 md:text-4xl">今日热瓜</h2>
          <p className="mt-2 max-w-xl text-sm text-foreground-600">
            按阅读热度排序，只保留当天最值得点开的几篇合集。
          </p>
        </div>
        <Link
          to="/gossip"
          className="flex w-fit items-center gap-1.5 whitespace-nowrap rounded-full border border-background-300 px-4 py-2 text-sm font-label text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-600 cursor-pointer"
        >
          查看全部合集
          <i className="ri-arrow-right-line" aria-hidden="true" />
        </Link>
      </div>

      <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-12">
        <article className="group relative overflow-hidden rounded-2xl border border-background-200 lg:col-span-7">
          <Link to={`/gossip/${featured.id}`} className="block cursor-pointer">
            <div className="h-64 w-full md:h-[380px]">
              <img
                src={featured.cover}
                alt={featured.coverAlt}
                className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
              />
            </div>
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/35 to-transparent" />
            <div className="absolute inset-x-0 bottom-0 flex flex-col gap-3 p-5 md:p-7">
              <span className="flex w-fit items-center gap-2 rounded-full bg-accent-500 px-3 py-1 text-xs font-label text-secondary-950">
                <i className="ri-article-line" aria-hidden="true" />
                编辑精选
              </span>
              <h3 className="font-heading text-2xl leading-snug text-background-50 md:text-3xl">
                {featured.title}
              </h3>
              <p className="line-clamp-2 max-w-2xl text-sm leading-relaxed text-background-200">
                {featured.summary}
              </p>
              <div className="flex flex-wrap items-center gap-4 text-xs text-background-300">
                <span className="flex items-center gap-1.5">
                  <i className="ri-user-line" aria-hidden="true" />
                  {featured.editor}
                </span>
                <span className="flex items-center gap-1.5">
                  <i className="ri-calendar-line" aria-hidden="true" />
                  {featured.date}
                </span>
                <span className="flex items-center gap-1.5">
                  <i className="ri-eye-line" aria-hidden="true" />
                  {formatCount(featured.readCount)}
                </span>
              </div>
            </div>
          </Link>
        </article>

        <ol className="flex flex-col gap-3 lg:col-span-5">
          {ranking.map((item, index) => (
            <li key={item.id} className="flex-1">
              <Link
                to={`/gossip/${item.id}`}
                className="group flex h-full items-center gap-4 rounded-xl border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300 hover:bg-primary-50 cursor-pointer"
              >
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-background-100 font-heading text-lg text-foreground-700 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                  {index + 1}
                </span>
                <span className="flex min-w-0 flex-1 flex-col gap-1.5">
                  <span className="line-clamp-1 font-heading text-base text-foreground-950">
                    {item.title}
                  </span>
                  <span className="flex flex-wrap items-center gap-3 text-xs text-foreground-500">
                    <span className="rounded-full bg-secondary-100 px-2 py-0.5 font-label text-secondary-900">
                      {item.category}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line" aria-hidden="true" />
                      {formatCount(item.readCount)}
                    </span>
                  </span>
                </span>
                <i
                  className="ri-arrow-right-line shrink-0 text-foreground-400 transition-transform group-hover:translate-x-1"
                  aria-hidden="true"
                />
              </Link>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}